import { render, staticRenderFns } from "./sbData.vue?vue&type=template&id=c59bfaec&scoped=true&"
import script from "./sbData.vue?vue&type=script&lang=js&"
export * from "./sbData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59bfaec",
  null
  
)

export default component.exports